export default "__VITE_ASSET__CR4t6_lk__"